import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { preserveAudienceLink } from "utils/audienceSafety";
import config from 'config/config';
import useAuth from 'hooks/useAuth';
import { PAGES } from 'config/config-general';

// types
import { GuardProps } from 'types/auth';


// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
   // --- Hooks --- //
   const {
      isLoggedIn,
      urlParams,
   } = useAuth();
   const navigate = useNavigate();
   const location = useLocation();
   const publicPasswordRoutes = ["/forgot-password", "/check-mail", "/reset-password"];

   // --- Effects --- //
   useEffect(() => {
      // Password-reset pages must remain usable even when this browser has an active session.
      if (publicPasswordRoutes.includes(location.pathname)) return;

      if (isLoggedIn) {
         // Check for link to page in url parameters
         if (urlParams && urlParams.has("page")) {
            const page = urlParams.get("page");
            urlParams.delete("page");
            // Check page validity
            if (PAGES.includes(page)) {
               navigate(preserveAudienceLink(page, location.search), { replace: true });
            } else {
               navigate(preserveAudienceLink(config.config.defaultPath, location.search), { replace: true });
            }
         } else {
            navigate(preserveAudienceLink(config.config.defaultPath, location.search), { replace: true });
         }
      } else {
         if (urlParams && urlParams.has("audience")
            && location.pathname !== "/anonymous-login"
            && !location.pathname.startsWith("/login")
            && !location.pathname.startsWith("/register")) {
            navigate(preserveAudienceLink("/anonymous-login", location.search), {replace: true});
         }
      }
   }, [isLoggedIn, location.pathname, location.search, navigate]);

   return children;
};

export default GuestGuard;
